import type { IToolManifest } from '@/core/tools/interfaces/ITool';
import i18n from '@/i18n/config';

export function bindGenogramToolName(manifest: IToolManifest, key: string, defaultValue: string) {
  const update = (lng?: string) => {
    const t = i18n.getFixedT(lng ?? i18n.language, 'genogram');
    manifest.name = t(key, { defaultValue }) as string;
  };

  update();
  const handler = (lng: string) => update(lng);
  i18n.on('languageChanged', handler);
}


